<template>
	<section>
		<b-form>
			<b-row>
				<b-col
					cols="12"
					md="6"
					class="mb-1"
				>
					<label>
						<strong>DOCUMENTOS GENERALES</strong>
					</label>
					<b-button-upload
						entity="REQUESTS"
						:entity-id="requestId"
						:is-disabled="true"
						:request-props="{ isGeneral: true }"
						:modal-props="{ title: 'DOCUMENTOS GENERALES' }"
						:button-props="{ text: 'VER DOCUMENTOS', block : true }"
						:any-file="true"
					/>
				</b-col>
			</b-row>
		</b-form>
	</section>
</template>

<script>
import BButtonUpload from "@core/components/b-button-upload/BButtonUpload.vue"
export default {
	components: {
		BButtonUpload
	},
	props: {
		requestId: {
			type: Number,
			required: true
		}
	}
}
</script>